<template>
  <div class="widget panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
